import { keyPathMirror } from 'key-path-mirror';

import { LocalesKey } from '../localesKeysTypes';

interface ColorsKeyType {
  plural: LocalesKey;
  attach: LocalesKey;
  colorSwatch: LocalesKey;
}

export const colorsKeys = keyPathMirror<ColorsKeyType, string>(
  {
    plural: null,
    attach: null,
    colorSwatch: null
  },
  'models.colors.'
);
